/**
 * Seating Module
 *
 * Handles seating-specific functionality including occupancy metrics refresh.
 */

import { $, ready } from '../utils/dom.js';

let refreshInterval = null;
const REFRESH_INTERVAL_MS = 30000; // 30 seconds

/**
 * Refresh occupancy metrics from API
 */
export function refreshMetrics() {
    fetch('/dashboard/api/occupancy-metrics')
        .then(response => response.json())
        .then(data => {
            if (data.success && data.data && data.data.length > 0) {
                let totalCapacity = 0;
                data.data.forEach(metric => {
                    if (metric.total_capacity) {
                        totalCapacity += metric.total_capacity;
                    }
                });

                const capacityEl = $('#total-capacity');
                if (capacityEl) {
                    capacityEl.textContent = totalCapacity;
                }
            }
        })
        .catch(error => console.error('Error refreshing metrics:', error));
}

/**
 * Start auto-refreshing metrics
 * @param {number} intervalMs - Refresh interval in milliseconds
 */
export function startAutoRefresh(intervalMs = REFRESH_INTERVAL_MS) {
    if (refreshInterval) {
        clearInterval(refreshInterval);
    }

    refreshMetrics(); // Initial load
    refreshInterval = setInterval(refreshMetrics, intervalMs);
}

/**
 * Stop auto-refreshing metrics
 */
export function stopAutoRefresh() {
    if (refreshInterval) {
        clearInterval(refreshInterval);
        refreshInterval = null;
    }
}

/**
 * Initialize seating dashboard
 */
function initSeating() {
    // Only auto-init if we're on a seating page with capacity element
    if ($('#total-capacity')) {
        startAutoRefresh();
    }
}

// Auto-initialize
ready(initSeating);

// Clean up on page unload
window.addEventListener('beforeunload', stopAutoRefresh);

// Expose globally
window.refreshMetrics = refreshMetrics;
window.startAutoRefresh = startAutoRefresh;
window.stopAutoRefresh = stopAutoRefresh;

export default {
    refreshMetrics,
    startAutoRefresh,
    stopAutoRefresh
};
